<div class="processing-container">
  <h2 class="processing-title">{{ data?.title || 'Processing' }}</h2>
  <p class="processing-message">
    {{ data?.message || 'Please wait while we import your locations...' }}
    <ng-container *ngIf="data?.total"> ({{ data?.total }} rows) </ng-container>
  </p>

  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>
